import { useTranslation } from "react-i18next";
import QuickContactForm from "./QuickContactForm";
import "../styles/CallToAction.css";

export default function CallToAction() {
  const { t } = useTranslation("cta");
  const trust = t("trust", { returnObjects: true });

  return (
    <section className="cta-section">
      <div className="cta-inner">

        <div className="cta-left">
          <span className="cta-eyebrow">{t("eyebrow")}</span>
          <h2 className="cta-title">
            {t("title").split("\n").map((line, i, arr) => (
              <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
            ))}
          </h2>
          <p className="cta-body">{t("body")}</p>
          <ul className="cta-trust">
            {trust.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <a href="/contactos" className="cta-link"><span>{t("link")}</span></a>
        </div>

        <div className="cta-right">
          <QuickContactForm />
        </div>

      </div>
    </section>
  );
}
